import httpClient from "../../../services/http";

export const addFeedBackComment = (data) =>
  httpClient.post(`utils-service/feedback`, data);

export default httpClient;